import type { CookieConsentInstance } from '#src/assets/core/types.ts'

export type CookieConsentEngine = {
  acceptAll: () => void
  rejectAll: () => void
  saveCategories: (categories: string[]) => void
  getAcceptedCategories: () => string[]
  hasValidConsent: () => boolean
}

export function createCookieConsentEngine(
  cookieConsent: CookieConsentInstance,
): CookieConsentEngine {
  return {
    acceptAll: () => {
      cookieConsent.acceptCategory('all')
    },
    rejectAll: () => {
      cookieConsent.acceptCategory([])
    },
    saveCategories: categories => {
      cookieConsent.acceptCategory(categories)
    },
    getAcceptedCategories: () => {
      if (!cookieConsent.validConsent()) {
        return ['necessary']
      }

      return cookieConsent.getCookie().categories
    },
    hasValidConsent: () => cookieConsent.validConsent(),
  }
}
